import React, { useEffect, useState } from "react";
import { Button, Chip } from "../ui";
import { IS_MOCK } from "../../services/config";
import * as engine from "../../services/ai/engine";
import { LLM_MODELS, fmtMB, getSelectedLlm, llmById, setSelectedLlm } from "../../services/ai/models";

/** สถานะของ engine (idle|loading|ready|error) แบบ reactive */
export function useLlmState() {
  const [s, setS] = useState(engine.getState());
  useEffect(() => {
    setS(engine.getState());
    return engine.subscribe(setS);
  }, []);
  return s;
}

/** เลือกโมเดล + ยอมรับดาวน์โหลด + แถบความคืบหน้า (ใช้ทั้งหน้าตั้งค่าและในห้องแชท) */
export default function LlmPanel() {
  const st = useLlmState();
  const [sel, setSel] = useState(getSelectedLlm());
  const [agree, setAgree] = useState(false);
  const m = llmById(sel);
  // ไม่ต้องถามก่อนดาวน์โหลดแล้ว (โหลดอัตโนมัติทุกหน้า)
  const consented = true;
  const loadingNow = st.status === "loading";
  const readyThis = st.status === "ready" && st.modelId === sel;

  if (IS_MOCK) return <p className="muted">โหมดทดลอง: ใช้ AI จำลอง ไม่ต้องดาวน์โหลดโมเดล</p>;
  if (!engine.isSupported()) {
    return <div className="notice notice--error" role="alert"><span className="grow">{engine.UNSUPPORTED_MSG}</span></div>;
  }

  const pick = (id) => {
    if (loadingNow) return;
    setSel(id);
    setSelectedLlm(id);
    setAgree(false);
  };
  const go = () => engine.load(sel);
  const pct = Math.round((st.progress || 0) * 100);

  return (
    <div>
      <p className="muted mb-8" style={{ fontSize: 13 }}>AI ทำงานในเบราว์เซอร์ของคุณ ข้อความแชทไม่ถูกส่งออกไปให้บริการ AI ภายนอก ดาวน์โหลดไฟล์โมเดลครั้งแรกครั้งเดียว แล้วเก็บไว้ในแคช ครั้งต่อไปโหลดเร็ว</p>
      {LLM_MODELS.length > 1 ? (
        <div className="chip-row" role="radiogroup" aria-label="เลือกโมเดล AI">
          {LLM_MODELS.map((x) => <Chip key={x.id} size="sm" active={sel === x.id} onClick={() => pick(x.id)}>{x.name} · {x.tier}</Chip>)}
        </div>
      ) : <div className="strong">{m.name} <span className="faint" style={{ fontWeight: 400 }}>· {m.tier}</span></div>}
      <p className="faint mt-8" style={{ fontSize: 12 }}>ดาวน์โหลดครั้งแรก ประมาณ {fmtMB(m.downloadMB)} · ใช้หน่วยความจำการ์ดจอประมาณ {fmtMB(m.vramMB)}{consented ? " · เคยดาวน์โหลดแล้ว" : ""}</p>

      {loadingNow ? (
        <div className="mt-8" role="status" aria-live="polite">
          <div className="progress" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}><i style={{ width: `${pct}%` }} /></div>
          <div className="faint mt-8" style={{ fontSize: 12 }}>กำลังโหลดโมเดล {pct}% {st.text ? "· " + st.text : ""}</div>
        </div>
      ) : readyThis ? (
        <p className="mt-8" role="status">พร้อมใช้งาน — {m.name}</p>
      ) : (
        <div className="mt-8 stack">
          {st.status === "error" && st.error ? <div className="error-text" role="alert">{st.error}</div> : null}
          {!consented ? (
            <label className="row" style={{ gap: 8, alignItems: "flex-start" }}>
              <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
              <span style={{ fontSize: 13 }}>ฉันยอมรับการดาวน์โหลดไฟล์โมเดลประมาณ {fmtMB(m.downloadMB)} (ควรใช้ Wi-Fi)</span>
            </label>
          ) : null}
          <div><Button variant="primary" onClick={go} disabled={!consented && !agree}>{consented ? "โหลดโมเดล" : `ดาวน์โหลดและใช้งาน (${fmtMB(m.downloadMB)})`}</Button></div>
        </div>
      )}
    </div>
  );
}
